import { Route, Routes } from 'react-router'
import Header from '../Header/Header'
import SideMenu from '../SideMenu/SideMenu'
import Content from '../Content/Content'

import Dashboard from '../../views/Dashboard/Dashboard'
import Calendario from '../../views/Calendario/Calendario'
import Planificacion from '../../views/Planificacion/Planificacion'
import Evaluacion from '../../views/Evaluacion/Evaluacion'
import Perfil from '../../views/Perfil/Perfil'

import AlumnoAsistencias from '../../views/Alumno/Asistencias/Asistencias'
import AlumnoFicha from '../../views/Alumno/Ficha/Ficha'
import AlumnoNotas from '../../views/Alumno/Notas/Notas'
import AlumnoEvaluacion from '../../views/Alumno/Evaluacion/Evaluacion'

import LeadFicha from '../../views/Lead/Ficha/Ficha'
import LeadContactos from '../../views/Lead/Contactos/Contactos'

import FormacionFicha from '../../views/Formacion/Ficha/Ficha'
import FormacionAsistencias from '../../views/Formacion/Asistencias/Asistencias'

import BarbeibotConsulta from '../../views/Barbeibot/Consulta/Consulta'
import BarbeibotHistorico from '../../views/Barbeibot/Historico/Historico'

import Horario from '../../views/Horario/Horario'
import MaterialCuadernillos from '../../views/Material/Cudernillos/Cuadernillos'
import MaterialGuiones from '../../views/Material/Guiones/Guiones'
import MaterialTemario from '../../views/Material/Temario/Temario'
import MaterialExamenes from '../../views/Material/Examenes/Examenes'
import MaterialVideos from '../../views/Material/Videos/Videos'

const Layout = () => (
  <>
    <Header />
    <SideMenu />
    <Content>
      <Routes>
        <Route path='/' element={<Dashboard />} />
        <Route path='/calendario' element={<Calendario />} />

        <Route path='/perfil' element={<Perfil />} />

        <Route path='/planificacion' element={<Planificacion />} />
        <Route path='/valoraciones' element={<Evaluacion />} />
        <Route
          path='/material/cuadernillos'
          element={<MaterialCuadernillos />}
        />
        <Route path='/material/guiones' element={<MaterialGuiones />} />
        <Route path='/material/temario' element={<MaterialTemario />} />
        <Route path='/material/examenes' element={<MaterialExamenes />} />
        <Route path='/material/videos' element={<MaterialVideos />} />

        <Route path='/horario' element={<Horario />} />

        <Route path='/alumnos/:id/ficha' element={<AlumnoFicha />} />
        <Route
          path='/alumnos/:id/asistencias'
          element={<AlumnoAsistencias />}
        />
        <Route path='/alumnos/:id/notas' element={<AlumnoNotas />} />
        <Route
          path='/alumnos/:id/evaluaciones'
          element={<AlumnoEvaluacion />}
        />

        <Route path='/leads/:id/ficha' element={<LeadFicha />} />
        <Route path='/leads/:id/contactos' element={<LeadContactos />} />

        <Route path='/formaciones/:id/ficha' element={<FormacionFicha />} />
        <Route
          path='/formaciones/:id/asistencias'
          element={<FormacionAsistencias />}
        />

        <Route path='/barbeibot/consulta' element={<BarbeibotConsulta />} />
        <Route path='/barbeibot/historico' element={<BarbeibotHistorico />} />
      </Routes>
    </Content>
  </>
)

export default Layout
